// @flow
import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useClient } from '../../hooks/client-context';
import _ from 'lodash';
import { NoData } from '../../../../shared';
import { SelectedPlans } from './selected-plans';


export const UserInput = () => {
  const client= useClient();
  const answers = getAnswersPairs(client.customAnswers ? JSON.parse(client.customAnswers) : undefined)

  return (
    <Stack gap={2}>
      <Typography variant="subtitle1">Quiz answers</Typography>
      {!answers.length && <NoData height={100} />}
      {answers.map((answer, index) => <Answer key={index} answer={answer} />)}
      <SelectedPlans />


      <Typography variant="subtitle1">Scope of Appointment</Typography>
      <Answer answer={{
        question: 'Do you plan to retire within the next 3 months?',
        answer: client.retireIn3Months || ''
      }} />
      <Answer answer={{
        question: 'Who are you booking for?',
        answer: client.bookingFor || ''
      }} />
      <Answer answer={{
        question: 'Plan types to discuss',
        answer: (client.planTypes || []).join(', ')
      }} />
      <Answer answer={{
        question: 'Additional information',
        answer: client.additionalInformation || ''
      }} />
    </Stack>
  );
};

const getAnswersPairs = (data: any): QA[] => {
  let result: QA[] = [];

  if (!data) {
    return result;
  }

  Object.keys(data).forEach(key => {
    if (_.isObject(data[key])) {
      if (data[key].answerText && data[key].questionText) {
        result.push({
          answer: data[key].answerText,
          question: data[key].questionText
        })
      } else if (['phone', 'email'].includes(data[key].value) && data[key].questionText) {
        result.push({
          answer: _.upperFirst(data[key].value),
          question: data[key].questionText
        })
      } else {
        result = [...result, ...getAnswersPairs(data[key])];
      }
    }
  })

  return result;
}


interface QA {
  question: string;
  answer: string;
}

const Answer = ({answer}: {answer: QA}) => {
  return <div>
    <Typography variant={'body2'}>{answer.question}</Typography>
    <Box ml={2}>
      <Typography color={'text.secondary'} variant={'caption'}>{answer.answer}</Typography>
    </Box>
  </div>
}
